/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TunnelClientCount,
  TunnelClientCount$inboundSchema,
} from "./tunnelclientcount.js";
import {
  TunnelMetricPoint,
  TunnelMetricPoint$inboundSchema,
} from "./tunnelmetricpoint.js";

/**
 * History availability
 */
export const TunnelMetricsState = {
  Available: "available",
  Unavailable: "unavailable",
  TooLarge: "too_large",
} as const;
/**
 * History availability
 */
export type TunnelMetricsState = OpenEnum<typeof TunnelMetricsState>;

export type TunnelMetrics = {
  /**
   * Distinct fronting MCP servers with requests in this range
   */
  activeServers: number;
  bucketSeconds: number;
  clients: Array<TunnelClientCount>;
  lastSampleAt?: Date | undefined;
  observedAt: Date;
  points: Array<TunnelMetricPoint>;
  /**
   * History availability
   */
  state: TunnelMetricsState;
};

/** @internal */
export const TunnelMetricsState$inboundSchema: z.ZodMiniType<
  TunnelMetricsState,
  unknown
> = openEnums.inboundSchema(TunnelMetricsState);

/** @internal */
export const TunnelMetrics$inboundSchema: z.ZodMiniType<
  TunnelMetrics,
  unknown
> = z.pipe(
  z.object({
    active_servers: z.int(),
    bucket_seconds: z.int(),
    clients: z.array(TunnelClientCount$inboundSchema),
    last_sample_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    observed_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    points: z.array(TunnelMetricPoint$inboundSchema),
    state: TunnelMetricsState$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "active_servers": "activeServers",
      "bucket_seconds": "bucketSeconds",
      "last_sample_at": "lastSampleAt",
      "observed_at": "observedAt",
    });
  }),
);

export function tunnelMetricsFromJSON(
  jsonString: string,
): SafeParseResult<TunnelMetrics, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunnelMetrics$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunnelMetrics' from JSON`,
  );
}
